import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <>
<div className="ln">

  {/* ============ NAV ============ */}
  <nav className="ln-nav">
    <div className="ln-nav__inner">
      <a href="#" className="ln-brand">
        <span className="ln-brand__mark">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2 4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4z" />
          </svg>
        </span>
        <span className="ln-brand__name">Rivelasta</span>
      </a>
      <div className="ln-nav__links">
        <a href="#funzioni" className="ln-nav__link">Funzioni</a>
        <a href="#processo" className="ln-nav__link">Come funziona</a>
        <a href="#casi" className="ln-nav__link">Casi d'uso</a>
        <a href="#contatti" className="ln-nav__link">Contatti</a>
        <Link to="/login" className="ln-nav__cta">Accedi</Link>
      </div>
    </div>
  </nav>

  {/* ============ HERO ============ */}
  <header className="ln-hero">
    <div className="ln-hero__inner">
      <div className="ln-hero__copy">
        <div className="ln-eyebrow"><i></i> Piattaforma per studi legali</div>
        <h1 className="ln-h1">
          Aste giudiziarie<br />gestite come una <em>pipeline</em>.
        </h1>
        <p className="ln-hero__lede">
          Rivelasta monitora i lotti in asta, abbina automaticamente lead e immobili,
          confronta valutazioni e tiene traccia delle trattative — in un unico workspace.
        </p>
        <div className="ln-hero__ctas">
          <a href="#contatti" className="ln-btn ln-btn--primary">
            <span>Richiedi offerta personalizzata</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
          <Link to="/login" className="ln-btn ln-btn--ghost">Accedi al workspace</Link>
        </div>
        <div className="ln-hero__signals">
          <span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Dati PVP aggiornati 24/7
          </span>
          <span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Conforme GDPR
          </span>
          <span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Onboarding 14 giorni
          </span>
        </div>
      </div>

      {/* Hero preview mock */}
      <div className="ln-preview" aria-hidden="true">
        <div className="ln-preview__bar">
          <span className="ln-preview__dot"></span>
          <span className="ln-preview__dot"></span>
          <span className="ln-preview__dot"></span>
          <span className="ln-preview__tab">rivelasta.app / match-inbox</span>
        </div>
        <div className="ln-preview__body">
          <div className="ln-preview__head">
            <div className="ln-preview__title">Match Inbox</div>
            <span className="ln-preview__pill">12 nuovi</span>
          </div>
          <div className="ln-preview__row">
            <span className="ln-preview__verdict" data-v="oro"></span>
            <span className="ln-preview__lead">
              <span className="ln-preview__lead-name">Famiglia Esposito</span>
              <span className="ln-preview__lead-target">Via Tuscolana 142 · Roma · Trilocale</span>
            </span>
            <span className="ln-preview__tag">A/3</span>
            <span className="ln-preview__price">€ 142.500</span>
          </div>
          <div className="ln-preview__row">
            <span className="ln-preview__verdict" data-v="verde"></span>
            <span className="ln-preview__lead">
              <span className="ln-preview__lead-name">Bianchi Investimenti</span>
              <span className="ln-preview__lead-target">Capannone · Milano Nord · 1.200 mq</span>
            </span>
            <span className="ln-preview__tag">D/7</span>
            <span className="ln-preview__price">€ 580.000</span>
          </div>
          <div className="ln-preview__row">
            <span className="ln-preview__verdict" data-v="verde"></span>
            <span className="ln-preview__lead">
              <span className="ln-preview__lead-name">Avv. Rossi (per cliente)</span>
              <span className="ln-preview__lead-target">Villa · Greve in Chianti</span>
            </span>
            <span className="ln-preview__tag">A/8</span>
            <span className="ln-preview__price">€ 412.000</span>
          </div>
          <div className="ln-preview__row">
            <span className="ln-preview__verdict" data-v="arancione"></span>
            <span className="ln-preview__lead">
              <span className="ln-preview__lead-name">De Luca Holdings</span>
              <span className="ln-preview__lead-target">Ufficio · Napoli centro</span>
            </span>
            <span className="ln-preview__tag">A/10</span>
            <span className="ln-preview__price">€ 218.000</span>
          </div>
          <div className="ln-preview__foot">
            <span>Asta 02/07 · scad. offerte 01/07</span>
            <span>Verdetto Rivelasta</span>
          </div>
        </div>
      </div>
    </div>
  </header>

  {/* ============ TRUST STRIP ============ */}
  <section className="ln-trust">
    <div className="ln-trust__inner">
      <div className="ln-trust__lbl">Usato da studi legali e notarili in tutta Italia</div>
      <div className="ln-trust__logos">
        <span className="ln-trust__logo">▲ Studio Conti</span>
        <span className="ln-trust__logo">◆ Lex Capital</span>
        <span className="ln-trust__logo">● Notai Associati</span>
        <span className="ln-trust__logo">◼ Iuris Group</span>
        <span className="ln-trust__logo">⬢ Forum Legale</span>
      </div>
    </div>
  </section>

  {/* ============ FUNZIONI ============ */}
  <section className="ln-section" id="funzioni">
    <div className="ln-section__inner">
      <div className="ln-section__head">
        <div className="ln-section__eyebrow">Funzioni</div>
        <h2 className="ln-h2">Tutto il flusso, dallo screening alla trattativa.</h2>
        <p className="ln-section__lede">
          Quattro moduli pensati per come gli studi lavorano davvero sulle aste giudiziarie:
          ricezione, qualifica, analisi, negoziazione.
        </p>
      </div>

      <div className="ln-features">
        <div className="ln-feat">
          <div className="ln-feat__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
              <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
            </svg>
          </div>
          <h3 className="ln-feat__title">Match Inbox</h3>
          <p className="ln-feat__body">
            Ogni nuovo lotto in asta viene confrontato con le esigenze dei tuoi lead.
            Vedi solo gli abbinamenti rilevanti, con un verdetto Rivelasta che sintetizza
            qualità del lotto, gap di prezzo e tempistica.
          </p>
          <div className="ln-feat__tags">
            <span className="ln-feat__tag">verdetto</span>
            <span className="ln-feat__tag">score</span>
            <span className="ln-feat__tag">whatsapp</span>
          </div>
        </div>

        <div className="ln-feat">
          <div className="ln-feat__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h3 className="ln-feat__title">Lead & Esigenze</h3>
          <p className="ln-feat__body">
            Anagrafica investitori e privati, esigenze multi-zona con raggio d'azione,
            tipologie catastali e budget. I match si attivano automaticamente quando un
            lotto rientra nei criteri.
          </p>
          <div className="ln-feat__tags">
            <span className="ln-feat__tag">zone</span>
            <span className="ln-feat__tag">catasto</span>
            <span className="ln-feat__tag">budget</span>
          </div>
        </div>

        <div className="ln-feat">
          <div className="ln-feat__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="4" y="2" width="16" height="20" rx="2" />
              <path d="M9 22v-4h6v4" />
              <path d="M8 6h.01" /><path d="M16 6h.01" />
              <path d="M12 6h.01" /><path d="M12 10h.01" /><path d="M12 14h.01" />
            </svg>
          </div>
          <h3 className="ln-feat__title">Tabella Immobili</h3>
          <p className="ln-feat__body">
            34 colonne configurabili — metrature, prezzi, gap di mercato, tribunale,
            modalità, PVP, analisi. Mostra solo quelle che ti servono nel momento,
            esporta e collegati direttamente alla scheda PVP o al report Rivelasta.
          </p>
          <div className="ln-feat__tags">
            <span className="ln-feat__tag">colonne</span>
            <span className="ln-feat__tag">€/mq</span>
            <span className="ln-feat__tag">PVP</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* ============ COME FUNZIONA ============ */}
  <section className="ln-section ln-section--alt" id="processo">
    <div className="ln-section__inner">
      <div className="ln-section__head">
        <div className="ln-section__eyebrow">Come funziona</div>
        <h2 className="ln-h2">Da nuovo lotto a trattativa aperta in tre passi.</h2>
      </div>

      <div className="ln-steps">
        <div className="ln-step">
          <div className="ln-step__num">Ingest</div>
          <h3 className="ln-step__title">I lotti entrano automaticamente</h3>
          <p className="ln-step__body">
            Rivelasta legge ogni giorno il Portale Vendite Pubbliche e i siti dei tribunali.
            Ogni lotto viene arricchito con valori di mercato, gap %, dati catastali.
          </p>
        </div>
        <div className="ln-step">
          <div className="ln-step__num">Match</div>
          <h3 className="ln-step__title">Confronto con le tue esigenze</h3>
          <p className="ln-step__body">
            Il motore confronta tipologia, metratura, prezzo e zona contro tutte le esigenze
            dei tuoi lead. Vedi solo gli abbinamenti con un verdetto attendibile.
          </p>
        </div>
        <div className="ln-step">
          <div className="ln-step__num">Contatta</div>
          <h3 className="ln-step__title">Componi e invia in un click</h3>
          <p className="ln-step__body">
            Un messaggio WhatsApp pre-compilato per ogni lead, con i dati del lotto e i
            link alla scheda. Quando il lead risponde, parte la trattativa.
          </p>
        </div>
      </div>
    </div>
  </section>

  {/* ============ CASI D'USO ============ */}
  <section className="ln-section" id="casi">
    <div className="ln-section__inner">
      <div className="ln-section__head">
        <div className="ln-section__eyebrow">Casi d'uso</div>
        <h2 className="ln-h2">Adatto a chi lavora sulle aste in modo strutturato.</h2>
      </div>

      <div className="ln-cases">
        <div className="ln-case">
          <div className="ln-case__role">Studi legali</div>
          <h3 className="ln-case__title">Pipeline ordinata per i clienti investitori</h3>
          <p className="ln-case__body">
            Tieni traccia delle esigenze, fai vedere solo le opportunità rilevanti, gestisci
            la corrispondenza e le offerte da un unico posto.
          </p>
          <ul className="ln-case__list">
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Multi-utente con ruoli</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Note e cronologia interazioni</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Esportazione report</li>
          </ul>
        </div>
        <div className="ln-case">
          <div className="ln-case__role">Notariati</div>
          <h3 className="ln-case__title">Visibilità sui lotti dei tribunali di riferimento</h3>
          <p className="ln-case__body">
            Segui solo i tribunali e le procedure che ti interessano, ricevi notifiche
            sulle scadenze offerte e monitora le aste deserte.
          </p>
          <ul className="ln-case__list">
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Filtri per tribunale</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Alert su tentativi consecutivi</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Link diretto al PVP</li>
          </ul>
        </div>
        <div className="ln-case">
          <div className="ln-case__role">Investitori</div>
          <h3 className="ln-case__title">Confronto rapido di decine di lotti</h3>
          <p className="ln-case__body">
            Mostra solo le colonne che pesano nella tua valutazione — €/mq, gap, ristrutturazione,
            liquidità — e ordina per opportunità.
          </p>
          <ul className="ln-case__list">
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>34 colonne configurabili</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Viste salvate</li>
            <li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>Esportazione CSV</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  {/* ============ STATS ============ */}
  <section className="ln-stats">
    <div className="ln-stats__inner">
      <div className="ln-stat">
        <div className="ln-stat__num"><em>~3.200</em></div>
        <div className="ln-stat__lbl">Lotti monitorati ogni settimana<br />sui tribunali italiani</div>
      </div>
      <div className="ln-stat">
        <div className="ln-stat__num"><em>14</em> gg</div>
        <div className="ln-stat__lbl">Tempo medio di onboarding<br />e migrazione dati</div>
      </div>
      <div className="ln-stat">
        <div className="ln-stat__num"><em>−68%</em></div>
        <div className="ln-stat__lbl">Tempo speso nello screening<br />manuale dei lotti</div>
      </div>
      <div className="ln-stat">
        <div className="ln-stat__num"><em>100%</em></div>
        <div className="ln-stat__lbl">Conforme GDPR · hosting<br />su data center europei</div>
      </div>
    </div>
  </section>

  {/* ============ CONTATTI ============ */}
  <section className="ln-contact" id="contatti">
    <div className="ln-contact__inner">
      <div className="ln-contact__intro">
        <div className="ln-section__eyebrow">Contatti</div>
        <h2>Costruiamo l'offerta su misura per il tuo studio.</h2>
        <p>
          Niente listino pubblico. Il prezzo dipende dal numero di utenti, dai tribunali
          monitorati e dall'eventuale integrazione con i tuoi gestionali. Compila il form
          o scrivici direttamente — ti rispondiamo entro un giorno lavorativo con una
          proposta concreta.
        </p>

        <div className="ln-contact__sla">
          <div className="ln-sla-row">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            <div>
              <b>commerciale@rivelasta.it</b>
              <span>Offerte personalizzate · risposta &lt;24h</span>
            </div>
          </div>
          <div className="ln-sla-row">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
            </svg>
            <div>
              <b>+39 02 4596 7720</b>
              <span>Lun–ven · 9:00–18:00 · italiano e inglese</span>
            </div>
          </div>
          <div className="ln-sla-row">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <div>
              <b>Demo dal vivo · 30 minuti</b>
              <span>Su appuntamento, con i tuoi tribunali di riferimento</span>
            </div>
          </div>
        </div>
      </div>

      <form className="ln-form" onsubmit="event.preventDefault(); document.getElementById('ln-form-sent').setAttribute('data-shown','true'); this.scrollIntoView({block:'start'});">
        <div className="ln-form__head">
          <h3 className="ln-form__title">Richiedi offerta personalizzata</h3>
          <span className="ln-form__pill">Risposta &lt;24h</span>
        </div>

        <div className="ln-form__grid">
          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-nome">Nome e cognome</label>
            <input id="f-nome" className="ln-form__input" type="text" placeholder="es. Marco Conti" required />
          </div>
          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-studio">Studio o azienda</label>
            <input id="f-studio" className="ln-form__input" type="text" placeholder="es. Studio Legale Conti" required />
          </div>

          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-email">Email professionale</label>
            <input id="f-email" className="ln-form__input" type="email" placeholder="nome@studio.it" required />
          </div>
          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-tel">Telefono</label>
            <input id="f-tel" className="ln-form__input" type="tel" placeholder="+39 …" />
          </div>

          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-dim">Dimensione team</label>
            <select id="f-dim" className="ln-form__select">
              <option>1–3 persone</option>
              <option>4–10 persone</option>
              <option>11–25 persone</option>
              <option>Oltre 25</option>
            </select>
          </div>
          <div className="ln-form__field">
            <label className="ln-form__lbl" htmlFor="f-ruolo">Ruolo</label>
            <select id="f-ruolo" className="ln-form__select">
              <option>Avvocato · Partner</option>
              <option>Avvocato · Associato</option>
              <option>Notaio</option>
              <option>Investitore privato</option>
              <option>Gestore patrimoniale</option>
              <option>Altro</option>
            </select>
          </div>

          <div className="ln-form__field ln-form__field--span">
            <label className="ln-form__lbl" htmlFor="f-msg">Cosa ti serve?</label>
            <textarea id="f-msg" className="ln-form__textarea" placeholder="Tribunali di interesse, numero di utenti, integrazioni richieste, tempistiche…"></textarea>
            <span className="ln-form__hint">Più dettagli ci dai, più precisa sarà l'offerta.</span>
          </div>
        </div>

        <button type="submit" className="ln-form__submit">
          <span>Invia richiesta</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
          </svg>
        </button>

        <p className="ln-form__legal">
          Inviando il modulo accetti che Rivelasta tratti i tuoi dati per rispondere alla richiesta,
          come descritto nella <a href="#" >Privacy Policy</a>. Nessuno spam, nessuna newsletter automatica.
        </p>

        <div id="ln-form-sent" className="ln-form__sent" role="status" aria-live="polite">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <span><b>Richiesta inviata.</b> Ti ricontattiamo entro un giorno lavorativo.</span>
        </div>
      </form>
    </div>
  </section>

  {/* ============ FOOTER ============ */}
  <footer className="ln-foot">
    <div className="ln-foot__inner">
      <div>© 2026 Rivelasta · Piattaforma per aste giudiziarie</div>
      <div className="ln-foot__links">
        <a href="#" >Termini</a>
        <a href="#" >Privacy</a>
        <a href="#" >Sicurezza</a>
        <a href="#" >Stato del servizio</a>
      </div>
    </div>
  </footer>

</div>
    </>
  );
}
